export const cruises = [
  {
    id: "mediterranean-dream",
    title: "Mediterranean Dream",
    duration: "10 Nights",
    ship: "Royal Caribbean - Symphony of the Seas",
    startingPrice: 1899,
    rating: 4.8,
    reviews: 234,
    image: "https://images.unsplash.com/photo-1612369218304-cf5ee316c473?w=800&q=80",
    ports: ["Barcelona", "Marseille", "Rome", "Naples", "Santorini", "Athens"],
    departurePort: "Barcelona, Spain",
    description: "Sail through the sparkling Mediterranean waters, visiting iconic ports from Barcelona's vibrant streets to the ancient wonders of Athens. Enjoy world-class dining, entertainment, and stunning ocean views.",
    highlights: [
      "Visit 6 stunning ports of call",
      "World-class dining & entertainment",
      "Infinity pool with ocean views",
      "Shore excursions included",
      "Formal captain's dinner"
    ]
  },
  {
    id: "caribbean-paradise",
    title: "Caribbean Paradise",
    duration: "7 Nights",
    ship: "Norwegian Cruise Line - Norwegian Bliss",
    startingPrice: 1299,
    rating: 4.7,
    reviews: 189,
    image: "https://images.unsplash.com/photo-1616423841125-8307665a0469?w=800&q=80",
    ports: ["Miami", "Cozumel", "Grand Cayman", "Jamaica", "Bahamas"],
    departurePort: "Miami, Florida",
    description: "Experience the Caribbean's most beautiful islands on this unforgettable cruise. Crystal-clear waters, white sandy beaches, and vibrant local culture await at every port of call.",
    highlights: [
      "5 tropical island stops",
      "Water slides & splash parks",
      "Snorkeling excursions",
      "Caribbean themed parties",
      "Private island beach day"
    ]
  },
  {
    id: "alaska-frontier",
    title: "Alaska Frontier Explorer",
    duration: "8 Nights",
    ship: "Princess Cruises - Discovery Princess",
    startingPrice: 2199,
    rating: 4.9,
    reviews: 156,
    image: "https://images.unsplash.com/photo-1704544705332-47ce3f05a0f2?w=800&q=80",
    ports: ["Seattle", "Juneau", "Skagway", "Glacier Bay", "Ketchikan"],
    departurePort: "Seattle, Washington",
    description: "Witness Alaska's breathtaking glaciers, majestic wildlife, and untouched wilderness on this epic voyage. From whale watching to glacier trekking, every moment is an adventure.",
    highlights: [
      "Glacier Bay scenic cruising",
      "Whale watching excursions",
      "Dog sledding on glaciers",
      "Gold Rush historical tours",
      "Wildlife photography opportunities"
    ]
  },
  {
    id: "greek-islands",
    title: "Greek Islands Explorer",
    duration: "12 Nights",
    ship: "Celebrity Cruises - Celebrity Apex",
    startingPrice: 2599,
    rating: 4.9,
    reviews: 142,
    image: "https://images.unsplash.com/photo-1497339047006-39f2b26f005d?w=800&q=80",
    ports: ["Athens", "Mykonos", "Santorini", "Rhodes", "Crete", "Corfu"],
    departurePort: "Athens (Piraeus), Greece",
    description: "Island hop through the stunning Greek archipelago. From Mykonos' nightlife to Santorini's sunsets, experience the best of Greek island life with luxurious onboard amenities.",
    highlights: [
      "6 Greek island visits",
      "Rooftop garden dining",
      "Infinity-edge hot tubs",
      "Greek wine tastings",
      "Ancient ruins guided tours"
    ]
  }
];

export const expeditions = [
  {
    id: "antarctic-explorer",
    title: "Antarctic Explorer: Discovering the 7th Continent",
    duration: "12 Days",
    ship: "Small-Ship Expedition · Ushuaia, Argentina",
    startingPrice: 8483,
    rating: 4.9,
    reviews: 312,
    image: "https://images.unsplash.com/photo-1531366936337-7c912a4589a7?w=800&q=80",
    badge: "Antarctica",
    region: "Antarctica",
    ports: ["Ushuaia", "Drake Passage", "South Shetland Islands", "Antarctic Peninsula"],
    departurePort: "Ushuaia, Argentina",
    description: "Set foot on the 7th continent on this classic Antarctic expedition. Zodiac landings on the peninsula put you face-to-face with penguin colonies, breaching humpback whales, and walls of ancient blue ice. Select departures aboard Ultramarine include twin-engine helicopter flights over glaciers.",
    highlights: [
      "Zodiac landings on the Antarctic Peninsula",
      "Penguin colonies & humpback whales",
      "Helicopter flights (select ships)",
      "Expert naturalist & scientist team",
      "Optional snow camping on the ice",
      "Open bar & Wi-Fi included"
    ]
  },
  {
    id: "emperor-penguin-quest",
    title: "Emperor Penguin Quest: Snow Hill Island",
    duration: "18 Days",
    ship: "Nuclear Icebreaker · Exclusive Access",
    startingPrice: 14995,
    rating: 5.0,
    reviews: 87,
    image: "https://images.unsplash.com/photo-1551986782-d0169b3f8fa7?w=800&q=80",
    badge: "Exclusive",
    region: "Antarctica",
    ports: ["Ushuaia", "Weddell Sea", "Snow Hill Island", "Antarctic Sound", "Antarctic Peninsula"],
    departurePort: "Ushuaia, Argentina",
    description: "One of the rarest wildlife encounters on Earth. An icebreaker powers deep into the Weddell Sea to reach Snow Hill Island — home to the world's most remote Emperor penguin colony. Helicopter transfers bring you within metres of thousands of the planet's largest penguins. Only a handful of expeditions in history have ever reached this colony.",
    highlights: [
      "Emperor penguin colony at Snow Hill Island",
      "Helicopter transfer to the colony",
      "Nuclear icebreaker through the Weddell Sea",
      "Expert ornithologists & glaciologists",
      "One of the rarest wildlife encounters on Earth",
      "Very limited departures — book early"
    ]
  },
  {
    id: "arctic-svalbard",
    title: "Arctic Svalbard: Polar Bears & Glaciers",
    duration: "10 Days",
    ship: "Small-Ship Expedition · Longyearbyen, Norway",
    startingPrice: 6995,
    rating: 4.8,
    reviews: 198,
    image: "https://images.unsplash.com/photo-1520769390460-2501729b05e4?w=800&q=80",
    badge: "Arctic",
    region: "Arctic",
    ports: ["Longyearbyen", "Svalbard Archipelago", "Ny-Ålesund", "Magdalenefjorden"],
    departurePort: "Longyearbyen, Svalbard, Norway",
    description: "Svalbard is the gateway to the High Arctic — a raw wilderness of glaciers, fjords, and polar wildlife. Encounter polar bears and walruses on ice floes, beluga whales surfacing beside the ship, and millions of seabirds nesting on sea cliffs. Navigate dramatic ice-carved landscapes with expert naturalist guides.",
    highlights: [
      "Polar bear & walrus encounters",
      "Zodiac cruising through calving glaciers",
      "Midnight sun photography",
      "Kayaking in Arctic fjords",
      "Expert naturalist lectures",
      "Northern lights (autumn departures)"
    ]
  },
  {
    id: "greenland-adventure",
    title: "Greenland: Icebergs, Vikings & the Inuit",
    duration: "12 Days",
    ship: "Small-Ship Expedition · Reykjavik, Iceland",
    startingPrice: 7495,
    rating: 4.9,
    reviews: 134,
    image: "https://images.unsplash.com/photo-1568702846914-96b305d2aaeb?w=800&q=80",
    badge: "Arctic",
    region: "Arctic",
    ports: ["Reykjavik", "Ilulissat Icefjord", "Disko Bay", "Nuuk", "Kangerlussuaq"],
    departurePort: "Reykjavik, Iceland",
    description: "Journey across the world's largest island, where colossal icebergs drift past ancient Viking settlements and Inuit communities. Walk on the Greenland Ice Sheet — the second-largest ice body on Earth — and stand before the thundering calving glaciers of the Ilulissat Icefjord, a UNESCO World Heritage Site.",
    highlights: [
      "Walk on the Greenland Ice Sheet",
      "Ilulissat Icefjord — UNESCO World Heritage",
      "Viking & Inuit cultural immersion",
      "Helicopter glacier flights",
      "Zodiac cruising among icebergs",
      "Expert glaciologist onboard"
    ]
  }
];
